import { ArticleEntity, EditArticle, EditArticleAppProps } from "../editArticle/editArticle"
import { GridCustomToolBarButton, ToolBarStandardButton, ToolBarStandardButtonType } from "../core/components/toolBar";
import { Grid } from "../core/components/grid";
import { Helper } from "../core/util/helper";
import { HTTPService, JsonResultClass } from "../core/util/httpManager";
import { General } from "../../siteManagement/general";
import { SheetEventType } from "../../siteManagement/sheet";
import { DialogHelper } from "../core/util/dialogHelper";
import { NotificationHelper } from "../core/util/notificationHelper";
import { getArticlesToBeSavedAsAssembly } from "../project/articlesToBeSavedAsAssembly";
import { AssemblyGroupViewElement, getFilteredGridData, setOptions } from "../baugruppen/assemblyGroupViewElements";
import { FullHeightContainer } from "../core/components/FullHeighContainer";
import {CopyMaterialDialog} from "../crReport/crReportMaterial";
import { TicketAppProps } from "./ticket";
import { Metadata } from "../core/components/commonApp";
import { AppMaterialState } from "../resourcePlanning/resourcePlanningMaterial";
import { GridArticle } from "../tasks/workPackage/workPackage";
import { Article } from "../commonInterfaces";
import { Config } from "../core/config/config";
import React from "react";
export default class MaterialGrid extends React.Component<TicketAppProps, AppMaterialState>{
    private _gridData = [];
    private _gridRef: Grid;
    private _gridOptions: kendo.ui.GridOptions;
    private _translations = {};
    private _dataUrl: string;
    private _enableUnpacked: boolean;

    constructor(props: TicketAppProps) {
        super(props)
        this._dataUrl = "ProcedureArticle/GetGridData?id=" + props.entity.ProblemNr;
        this._translations = props.translations;
        this._enableUnpacked = false;
        this.state = {
            deleteButton: true,
            editButton: true,
            gridData: [],
            summarized: false,
            onlyParents: false,
            materialCustomButtonSettings: {
                summarize: true,
                unpack: true
            },
            showCopyDialog: false
        };
        this.setOptions(this.state.summarized, this.state.onlyParents);
    }

    private setOptions(summarized: boolean, onlyParents: boolean) {
        this._gridOptions = setOptions(summarized, onlyParents, this.props.context.materialGrid);
        if (this._getCopyMat2MachActive()) {
            this._gridOptions.selectable = "multiple, row";
            const selectColumn = {
                selectable: true, width: "50px", title: " ", field: "select", filterable: false, sortable: false
            };
            this._gridOptions.columns.splice( 0, 0, selectColumn);
        }
    }

    private _getGridData() {
        HTTPService.get(this._dataUrl)
            .then(result => {
                this._gridData = result.Data.GridData;

                let filteredGridData: VorgangArtikelViewModel[] = getFilteredGridData(this.state.summarized, this.state.onlyParents, this._gridData);

                this.setState({
                    gridData: filteredGridData
                });
            });
    }

    private _openEditWindow = (dataItem: any) => {
        HTTPService.chainBatch
            .add<JsonResultClass<ArticleEntity>>('ProcedureArticle/Init?problemNr=' + encodeURIComponent(this.props.entity.ProblemNr) + (Helper.hasValue(dataItem) ? "&pos=" + dataItem.Pos : ""))
            .add<Metadata>(Helper.getMetaData("procedureArticle"))
            .promise()
            .then(result => {
                let article = result[0].Data as ArticleEntity;
                article.Adrnr = this.props.entity.Adresse_Key;
                const articleEditProps = {
                    entity: article,
                    metadata: result[1],
                    context: {
                        key1: "entity.ProblemNr", keyVal1: this.props.entity.ProblemNr,
                        key2: "entity.Pos", keyVal2: ((this.props.entity) as any).Pos,
                        contextType: "ticketArticleEdit" },
                    dataSources: {},
                    isWindow: true,
                    title: "",
                    saveUrl: "ProcedureArticle/SaveArticle"
                } as EditArticleAppProps

                const sheet = General.Sheet.Manager.createSheet();
                sheet.setTitle(this._translations["Vorgang.ArtikelZumVorgang"]);
                sheet.bind(SheetEventType.SavedSuccessfully, (_) => {
                    this._getGridData();
                });
                sheet.show(() => {
                    sheet.mountContent(EditArticle, articleEditProps);
                })}
            );
    }

    create = () => {
        const sheet = General.Sheet.Manager.createSheetWithUrl("DynamicSearch/Window/Article?multi=true&displayPattern=[[bezeichnung]]",{ disableTabTitle: true });
        sheet.setTitle(this._translations["Vorgang.ArtikelZumVorgang"]);
        sheet.bind(SheetEventType.ItemsSelected, async (e: { data: Array<Article> }) => {
            if (Array.isArray(e.data) && e.data.length > 0) {
                let vorgangArtikelViewModelLst :VorgangArtikelViewModel[] = [];            
                for (let i = 0; i < e.data.length; i++) {
                    let vorgangArtikel = Helper.createEmptyEntity() as VorgangArtikelViewModel;
                    vorgangArtikel.Artikelnummer = e.data[i].artikelnummer;
                    vorgangArtikel.Artikelnr = e.data[i].artnr;
                    vorgangArtikel.Anzahl = 1;
                    vorgangArtikel.Datum = new Date();
                    vorgangArtikel.Produkt = e.data[i].produkt;
                    vorgangArtikel.Chargennr = e.data[i].chargennr;
                    vorgangArtikel.Seriennr = e.data[i].seriennr;
                    vorgangArtikel.EkPreis = e.data[i].ekpreis;
                    vorgangArtikel.Epreis = e.data[i].preis;
                    vorgangArtikel.Gpreis = e.data[i].preis;
                    vorgangArtikel.Kosten = e.data[i].ekpreis;
                    vorgangArtikel.Bezeichnung = e.data[i].bezeichnung;
                    vorgangArtikel.Rabatt = 0;
                    vorgangArtikel.ProblemNr = this.props.entity.ProblemNr;
                    vorgangArtikel.IsUnpacked = false;
                    vorgangArtikel.CanBeUnpacked = e.data[i].isassemblygroup;
                    vorgangArtikelViewModelLst.push(vorgangArtikel);
                }
                const articlesToBeSavedAsAssembly = await getArticlesToBeSavedAsAssembly(vorgangArtikelViewModelLst);

                const result = await HTTPService.post<JsonResultClass<VorgangArtikelViewModel[]>>("ProcedureArticle/SaveArticles", vorgangArtikelViewModelLst);
                const code = result.Code;
                const message = result.Message;
                const articleResult = result.Data;

                if (code == 0) {
                    let parents = articleResult.filter(a => a.CanBeUnpacked && articlesToBeSavedAsAssembly.findIndex(i => i === a.Artikelnr) !== -1);
                    let assemblyResultCode = 0;
                    if (parents.length > 0) {
                        const assemblyResult = await HTTPService.post<JsonResultClass<boolean>>("ProcedureArticle/UnpackAssemblyGroupParts", {parentParts: parents});
                        assemblyResultCode = assemblyResult.Code;
                        if (assemblyResult.Code == 1) {
                            NotificationHelper.showErrorMessage(assemblyResult.Message);
                        }
                    }
                    if (code == 0 || assemblyResultCode == 0)
                        this._getGridData();
                }
                else
                    NotificationHelper.showErrorMessage(message);
            }
        });
       
    }

    open = (dataItem: any) => {
        this._openEditWindow(dataItem);
    }

    remove = (dataItem: any) => {
        DialogHelper.confirm(this.props.translations["Standard.Msg.Loeschen"]).then(isOk => {
            if (isOk) {
                const url = 'ProcedureArticle/Delete?problemnr=' + this.props.entity.ProblemNr + '&pos=' + dataItem.Pos;
                HTTPService.post(url)
                    .then(_ => {
                        this._getGridData();
                    });
            }
        });
    }

    removeEx = (allItems: any[]) => {
        DialogHelper.confirm(this.props.translations["Standard.Msg.Loeschen"]).then(isOk => {
            if (isOk) {
                const positions: number[] = [];
                allItems.forEach(a => positions.push(a.Pos));
                HTTPService.post("ProcedureArticle/DeleteEx", { problemnr: this.props.entity.ProblemNr, positions: positions })
                    .then(_ => {
                        this._getGridData();
                    });
            }
        });
    }

    handleClickStandardButton = (type: ToolBarStandardButtonType, dataItem: any, allItems?: Array<any>) => {
        if (type === ToolBarStandardButtonType.NEW) {
            this.create();
        } else if (type === ToolBarStandardButtonType.EDIT) {
            this.open(dataItem);
        } else if (type == ToolBarStandardButtonType.DELETE) {
            
            //console.log("dataItem: ", dataItem, "allItems: ", allItems);
            
            if (allItems == null) 
                this.remove(dataItem)
            else 
                this.removeEx(allItems);
        }
    }

    handleClickCustomButton = async (id: string, dataItem: any, allItems?: Array<any>) => {
        if (id === "addToProject") {
            const sheet = General.Sheet.Manager.createSheetWithUrl("DynamicSearch/Window/ticketArticle?multi=true&displayPattern=[[artnr]]-[[artikelnummer]]-[[produkt]]&cusData1=" + encodeURIComponent(this.props.entity.ProblemNr), null, { disableTabTitle: true });
            sheet.setTitle(this._translations["Vorgang.ArtikelZumVorgang"]);
            sheet.bind(SheetEventType.ItemsSelected, (e) => {
                if (Array.isArray(e.data)) {
                    const pos = [];
                    for (let i = 0; i < e.data.length; i++) {
                        pos.push(e.data[i].pos);
                    }
                    if (pos.length > 0) {
                        HTTPService.get("ProcedureArticle/CopyToProject/?" + $.param({
                            problemNr: this.props.entity.ProblemNr,
                                projNr: this.props.entity.Projekt_Key,
                                pos: pos
                            }, true)
                        ).then(_ => {
                            
                        });
                    }
                }
            });
        }

        if (id === "TID_ImportShoppingCart") {
            this.__TIDimnportShppingCart(this.props.entity.ProblemNr)
        }
        
        if (id === "unpack") {
            // Kopf raus, Kinder rein
            let result = await HTTPService.post<JsonResultClass<boolean>>("ProcedureArticle/UnpackAssemblyGroupPart", { parentPart: dataItem });
            if (result.Code === 0) {
                this._getGridData();
            }
            else {
                NotificationHelper.showErrorMessage(result.Message);
            }
        }
        
        if (id === "summarize") {
            let result = await HTTPService.post<JsonResultClass<boolean>>("ProcedureArticle/SummarizeArticles", { problemNr: this.props.entity.ProblemNr });
            if (result.Code === 0) {
                this._getGridData();
            }
            else {
                NotificationHelper.showErrorMessage(result.Message);
            }
        }
        
        if (id === "MaterialKopieren") {
            if (!this.props.entity.IsNew && this.props.entity.RecordRight.CanWrite) {
                const selectedArticles: number[] = [];
                allItems.forEach(a => { selectedArticles.push(a.Pos) });
                    
                const machines = await this.getTicketMachines();
                if (machines == null || selectedArticles.length == 0)
                    return;
                this.setState({showCopyDialog: true, machines: machines, selectedArticles: selectedArticles});
            }
        }
    }


    private __TIDimnportShppingCart = (problemNr: number) => {
        const url = "TidInnosoft/processTIDShoppingCart";
        HTTPService.post<JsonResultClass>(url, {problemNr: problemNr}).then(result => {
                    if (result.Code == 0) {
                        if (!Helper.isNullOrEmpty(result.Message)) {
                            //not all articeles are added, confirm to delete shopping cart 
                            DialogHelper.confirm(this.props.translations["WebSMS.Ticket.TIDArticleMissedMsg"] + "<br/>" +
                                result.Message + "<br/><br/>" + this.props.translations["WebSMS.Ticket.TIDdeleteShoppingCartConfirm"]).then(isOk => {
                                    if (isOk) {
                                        this.__TIDdeleteShppingCart(problemNr);
                                    }
                                    else
                                        this._getGridData();
                                });
                        }
                        else {
                            //simple delete 
                            this.__TIDdeleteShppingCart(problemNr);    
                        }
                    } else {
                        NotificationHelper.showErrorMessage(result.Message);
                    }
                });
    }

    private __TIDdeleteShppingCart = (problemNr: number) => {
        const url = "TidInnosoft/deleteTIDShoppingCart";
        HTTPService.post<JsonResultClass>(url, {problemNr: problemNr}).then(result => {
            if (result.Code == 0) {
                        this._getGridData();              
                        NotificationHelper.showSuccessMessage(this.props.translations["WebSMS.Ticket.TIDOk"]);
                    } else {
                        NotificationHelper.showErrorMessage(result.Message);
                    }
                });
    }

    onSelectionChanged = (dataItem: any) => {
        //"onSelectionChanged: ", dataItem)

        if (dataItem == null)
        {
            //no selection, call render => button update
            if (this._getCopyMat2MachActive())
                this.setState({}); 
            return;
        }
        
        if (!Array.isArray(dataItem))
        {
            let canBeUnpacked = dataItem.CanBeUnpacked;
            this._enableUnpacked = Helper.hasValue(canBeUnpacked) ? canBeUnpacked : false;
           
            const enableButtons = !dataItem.Summarized && !dataItem.IsUnpacked;
            const newSettings = {
                summarize: !Helper.hasValue(dataItem.ResolvedFrom),
                unpack: this.state.materialCustomButtonSettings.unpack
            };

            this.setState({
                editButton: enableButtons,
                deleteButton: enableButtons,
                materialCustomButtonSettings: newSettings
            });
        }
        else {
            //enable only 
            this._enableUnpacked = false;
            const enableDelete = dataItem.filter(f => f.Summarized || f.IsUnpacked).length == 0;
            const newSettings = {
                summarize: false,
                unpack: false
            };
            this.setState({
                editButton: false,
                deleteButton: enableDelete,
                materialCustomButtonSettings: newSettings
            });
            
        }
    }

    componentDidMount() {
        this._getGridData();
    }

    private changeOptions = (newSummarized: boolean, newOnlyParents: boolean) => {
        let customButtonSettings = {
            summarize: !newSummarized,
            unpack: !newSummarized
        };
        this.setOptions(newSummarized, newOnlyParents);

        let gridData = getFilteredGridData(newSummarized, newOnlyParents, this._gridData);

        this.setState({
            onlyParents: newOnlyParents,
            summarized: newSummarized,
            materialCustomButtonSettings: customButtonSettings,
            gridData: gridData
        });
    }
    
    private getTicketMachines = async (): Promise<{ MachineNumber: string, Maschbezeichnung: string }[]> => {
        const res =
            await HTTPService.get<JsonResultClass<any[]>>("Procedure/GetMachines?problemNr=" + this.props.entity.ProblemNr);
        if (res.Code == 0) {
            const arr: { MachineNumber: string, Maschbezeichnung: string }[] = [];
            res.Data.forEach(m => { arr.push( { MachineNumber: m.Id, Maschbezeichnung: Helper.hasValue(m.Maschbezeichnung) ? m.Maschbezeichnung : m.Id  } ) } );
            return arr;
        }
        return null;
    }

    _handleCopy = async (selectedMachines: string[]) => {
        const res = await HTTPService.post(`CrReportMaterial/CopyToOtherMachinesEx?ticketNo=${this.props.entity.ProblemNr}`,
            { SelectedArticles: this.state.selectedArticles, SelectedMachines: selectedMachines })
        if (res.Code === 0) {
            NotificationHelper.showSuccessMessage(Helper.getTranslation("WebSMS.Ticket.Mat2MachCopied"));
        } else {
            NotificationHelper.showErrorMessage(res.Message);
        }
    }
    
    private _getQuanosActive() {
        return this.props.context.isTIDActive === true;
    }
    
    private _getCopyMat2MachActive() {
        return this.props.context.isCopyMaterialToMashActive === true;
    }
    
    render() {
        
        let selected = 0;
        if (Helper.hasValue(this._gridRef)) {
            const select = this._gridRef.getGridRef().select();
            if (select != null)
                selected = select.length;
        }

        //console.log("selected: ", selected, "this.state.deleteButton: ", this.state.deleteButton);

        const { RecordRight } = this.props.entity;

        const standardButtons: Array<ToolBarStandardButton> = [];
        standardButtons.push({ type: ToolBarStandardButtonType.NEW, caption: Helper.getTranslation("Standard.Add"), enabled: RecordRight.CanWrite });
        standardButtons.push({ type: ToolBarStandardButtonType.EDIT, caption: this._translations["Standard.Editieren"], enabled: RecordRight.CanWrite && this.state.editButton && selected == 1 });
        standardButtons.push({ type: ToolBarStandardButtonType.DELETE, caption: this._translations["Standard.Loeschen"], enabled: RecordRight.CanWrite && this.state.deleteButton });

        const customButtons: Array<GridCustomToolBarButton> = [];
        //Quanos
        if (this._getQuanosActive() && !Config.settings.isMobileApp)
            customButtons.push({ caption: this._translations["WebSMS.Ticket.TIDImportFromShoppingCart"], 
                enabled: this.props.entity.RecordRight.CanWrite, autoEnabledOnRecordSelected: false, id: "TID_ImportShoppingCart", iconClass: "k-i-cart" })
        //Copy mat => anlage
        if (this._getCopyMat2MachActive()) {
            //console.log("selected: ", selected, "this.state.onlyParents: ", this.state.onlyParents, "this.state.summarized: ", this.state.summarized);
            customButtons.push({ caption: "Material kopieren", 
                enabled: this.props.entity.RecordRight.CanWrite && selected > 0 && !this.state.onlyParents && !this.state.summarized,
                autoEnabledOnRecordSelected: false, 
                id: "MaterialKopieren",
                iconClass: "k-i-copy",
                useContextMenu: true
            })
        }
        //Unpack
        customButtons.push({ autoEnabledOnRecordSelected: true, 
            caption: this._translations["Vorgang.Unpack"], 
            enabled: this.props.entity.RecordRight.CanWrite && 
                this._enableUnpacked  && 
                this.state.materialCustomButtonSettings.unpack, 
            iconClass: "k-i-redo",
            id: "unpack",
            useContextMenu: true
        });
        
        // Erstmal ausblenden da es sowieso kaum Anwendung finden könnte
        //customButtons.push({ autoEnabledOnRecordSelected: true, caption: this._translations["Vorgang.SummarizeParts"], enabled: this.props.entity.RecordRight.CanWrite && this.state.materialCustomButtonSettings.summarize, iconClass: "k-i-redo", id: "summarize" });
        
        const content = 
            <Grid ref={(r) => this._gridRef = r}
                data={this.state.gridData}
                options={this._gridOptions}
                id={"ticketMaterial" + this._getQuanosActive() ? "_V2" : ""}
                standardButtons={standardButtons}
                onClickStandardButton={this.handleClickStandardButton}
                customButtons={customButtons}
                onClickCustomButton={this.handleClickCustomButton}
                onSelectionChanged={this.onSelectionChanged}
                gridDetails={{
                    useFeature: true
                }}
                useFloatingButtons={true}
            />

        const dialog = this.state.showCopyDialog ? 
            <CopyMaterialDialog
                machines={this.state.machines}
                onClose={() => this.setState({ showCopyDialog: false, machines: null, selectedArticles: null }, () => this._getGridData() )}
                onCopy={this._handleCopy} /> : null;
        
        return (
            <FullHeightContainer>
                <AssemblyGroupViewElement changeOptions={this.changeOptions} onlyParents={this.state.onlyParents} summarized={this.state.summarized} />
                {content}
                {dialog}
            </FullHeightContainer>
        );
    }
}
interface VorgangArtikelViewModel extends GridArticle{
    ProblemNr?: number;
}